import React, { memo } from 'react';
import styled, { css } from 'styled-components';

import { translate } from '../../../common/translation/translate';

interface ErrorBoundaryInfoProps {
    title?: string;
    description: string;
}

const defaultTitle = translate('failedToLoad');
const defaultDescription = translate('checkNetworkConnectivity');
export const ErrorBoundaryInfo = memo(({ title = defaultTitle, description = defaultDescription }: ErrorBoundaryInfoProps) => {
    return (
        <Container>
            <FailedToLoadTitle>
                {title}
            </FailedToLoadTitle>
            <ErrorDescription>
                {description}
            </ErrorDescription>
        </Container>
    );
});

ErrorBoundaryInfo.displayName = 'ErrorBoundaryInfo';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px;
    width: 100%;
    height: 84px;
    color: #333333;
`;

const TextBaseStyles = css`
    display: flex;
    align-items: center;
    text-align: center;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
`;

const FailedToLoadTitle = styled.div`
    ${TextBaseStyles}
    height: 28px;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
`;

const ErrorDescription = styled.div`
    ${TextBaseStyles}
    width: 280px;
    height: 40px;
    font-size: 16px;
    line-height: 20px;
`;
